import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './locales/en';
import { ja } from './locales/ja';
import { zh } from './locales/zh';
import {
  MINDCLOUD_BRIDGE_EVENTS,
  subscribeParentMessages,
  isParentBridgeAvailable,
} from '@/services/parentBridge';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
      ja: { translation: ja },
    },
    fallbackLng: 'zh',
    supportedLngs: ['zh', 'en', 'ja'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
  });

// 前端 locale code → Explorer locale code（前端用 zh-CN，Explorer 用 zh）
function mapLocale(locale: string): string {
  if (locale.startsWith('zh')) return 'zh';
  if (locale.startsWith('en')) return 'en';
  if (locale.startsWith('ja')) return 'ja';
  return 'zh';
}

// iframe 模式下监听父页面语言切换，实时同步
if (isParentBridgeAvailable()) {
  subscribeParentMessages((message) => {
    if (message.type !== MINDCLOUD_BRIDGE_EVENTS.hostLocaleChange) return;
    const payload = message.payload as { locale?: string } | undefined;
    if (payload?.locale) {
      const mapped = mapLocale(payload.locale);
      if (mapped !== i18n.language) {
        void i18n.changeLanguage(mapped);
      }
    }
  });
}

export default i18n;
